import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box} from 'views/components';

import ClientLeadTitle from './title/ClientLeadTitle';
import ClientLeadDescription from './description/ClientLeadDescription';
import ClientLeadPhoto from './photo/ClientLeadPhoto';
import ClientLeadShowSettings from './ClientLeadShowSettings';
import ClientLeadAnnouncement from './announcement/ClientLeadAnnouncement';

const ClientLeadHeader = (props) => {
  const clientLeadRn = props.clientLeadRn;
  const clientLeadData = props.clientLeadData;
  const clientLeadBackend = props.clientLeadBackend;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;
  const showSettings = props.showSettings;
  const setOpenDrawerView = props.setOpenDrawerView;

  return (
    <Stack>
      <ClientLeadTitle
        clientLeadRn={clientLeadRn}
        clientLeadData={clientLeadData}
        clientLeadBackend={clientLeadBackend}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <Stack direction={{md: 'row', xs: 'column'}}>
        <Box
          sx={{
            width: {md: '20%', xs: '100%'},
          }}
        >
          <ClientLeadPhoto
            clientLeadRn={clientLeadRn}
            clientLeadData={clientLeadData}
            clientLeadBackend={clientLeadBackend}
          />
        </Box>
        <Box
          sx={{
            width: {md: '80%', xs: '100%'},
          }}
        >
          <ClientLeadDescription
            clientLeadRn={clientLeadRn}
            clientLeadData={clientLeadData}
            clientLeadBackend={clientLeadBackend}
          />
        </Box>
      </Stack>
      <ClientLeadAnnouncement
        clientLeadRn={clientLeadRn}
        clientLeadData={clientLeadData}
        clientLeadBackend={clientLeadBackend}
      />
      <ClientLeadShowSettings
        clientLeadRn={clientLeadRn}
        clientLeadData={clientLeadData}
        clientLeadBackend={clientLeadBackend}
        showSettings={showSettings}
        setOpenDrawerView={setOpenDrawerView}
      />
    </Stack>
  );
};
ClientLeadHeader.propTypes = {
  clientLeadRn: PropTypes.string.isRequired,
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
  showSettings: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

export default React.memo(ClientLeadHeader);
